import { useState } from 'react';
import { TextField, Typography } from '@mui/material';
import EditNoteRounded from '@mui/icons-material/EditNoteRounded';
import MLToast from 'components/common/Toast/Toast';
import TSButton from 'components/common/Button/Button';
import TSCard from 'components/common/TSCard/TSCard';
import { useWritePlanNotesMutation } from 'app/api/planApiSlice';

// The walker's own notes on a Plan, such as route variations or where they
// intend to camp. Saved with Save; read-only once the Plan has started.
const PlanNotes = ({ planId, notes, editable = true }) => {
  const { showToast } = MLToast();
  const [text, setText] = useState(notes ?? '');
  const [writeNotes, { isLoading }] = useWritePlanNotesMutation();

  const handleSave = async () => {
    const res = await writeNotes({ planId, notes: text });
    if (res.error) {
      showToast(res.error.data?.message || 'Something went wrong!', 'error');
    } else {
      showToast('Notes saved', 'success');
    }
  };

  return (
    <TSCard icon={<EditNoteRounded />} title="Notes">
      {editable ? (
        <>
          <TextField
            multiline
            minRows={3}
            label="Your notes"
            helperText="For example: route changes, or where you plan to camp."
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <div>
            <TSButton
              btnText={isLoading ? 'Saving...' : 'Save notes'}
              btnVariant="outlined"
              btnDisable={isLoading || text.trim() === (notes ?? '')}
              onClickFunc={handleSave}
            />
          </div>
        </>
      ) : (
        <Typography variant="body1" className="whitespace-pre-line">
          {notes || 'No notes.'}
        </Typography>
      )}
    </TSCard>
  );
};

export default PlanNotes;
